import React, { useEffect } from "react";
import { CallAPI } from "services/API";
import TableWithContainer from "utils/Table/TableWithContainer";
import TooltipButton from "utils/TooltipButton/TooltipButton";

export default function Renewals(props) {
    const integer = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const percent = new Intl.NumberFormat('en-US', { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const headers = [["", "Policies", "GWP"]];

    const [data, setData] = React.useState([
        ["Average Renewal Premium Bound", currency.format(0)],
        ["Up for Renewal", integer.format(0), currency.format(0)],
        [<>Renewed<TooltipButton tooltipText="includes reinstatements" /></>, integer.format(0), currency.format(0)],
        ["Reinstated", integer.format(0), currency.format(0)],
        ["Renewal %", percent.format(0)]
    ]);
    const [loading, setLoading] = React.useState(false);

    const GetData = async () => {
        const response = await CallAPI("POST", `/Home/GetRenewals`, {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city
        });

        if (response) {
            const formattedResponse = [
                [
                    "Average Renewal Premium Bound",
                    currency.format(response.averagePremium)
                ], [
                    "Up for Renewal",
                    integer.format(response.upForRenewalPolicies),
                    currency.format(response.upForRenewalGWP)
                ], [
                    <>Renewed<TooltipButton tooltipText="includes reinstatements" /></>,
                    integer.format(response.renewedPolicies),
                    currency.format(response.renewedGWP)
                ], [
                    "Reinstated",
                    integer.format(response.reinstatedPolicies),
                    currency.format(response.reinstatedGWP)
                ], [
                    "Renewal %",
                    percent.format(response.renewalPercentage / 100)
                ]
            ];

            if (props.comments?.length > 0) {
                headers[0].push('');
                formattedResponse.map(x => {
                    let comment = props.comments.find(y => y.row.toLowerCase() == x[0].toLowerCase());
                    x.push(comment ? comment.message : '');
                });
            }

            setData(formattedResponse);
        }

        setLoading(false);
    };

    useEffect(() => {
        if (props.call === "true" || props.call === null) {
            GetData();
            setLoading(true);
        }
    }, [props.call]);

    return (
        <div>
            <TableWithContainer
                title="RENEWALS"
                subtitle={<>
                    <span style={{ color: "#ff8000", fontWeight: "300" }}>
                        {data.find(x => x[0] === "Average Renewal Premium Bound")[1]}&nbsp;
                    </span>
                    <span>Average Renewal Premium Bound</span>
                </>}
                loading={loading}
                fixedColumns={1}
                style={{
                    Table: {
                        TableSX: { tableLayout: 'fixed' }, // all columns same width
                    }
                }}
                headers={headers}
                rows={data.filter(x => x[0] !== "Average Renewal Premium Bound")}
                exportName="Renewals"
            />
        </div>
    );
};
